module.exports = __webpack_public_path__ + "assets/img/404_2.86f9e57e.png";